import { FormControlLabel, styled } from '@mui/material';

export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: '-0.9rem',
  '& .MuiFormControlLabel-label': {
    ...theme.typography.label,
    color: theme.palette.grey[500],
    '&.Mui-disabled': {
      color: theme.palette.grey[500],
    },
  },
})) as typeof FormControlLabel;
